import { Link } from "react-router-dom";

const LINKS = [["Programs", "/#programs"], ["Tuition", "/#tuition"], ["Careers", "/careers"], ["Contact", "/#contact"]];

export const PublicShell = ({ children, testid = "public-page" }) => (
  <div className="min-h-screen bg-[#F8FAFC]" data-testid={testid}>
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/90 border-b border-border/60">
      <div className="mx-auto max-w-6xl px-5 sm:px-8 h-20 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3" data-testid="shell-brand">
          <span className="h-11 w-11 rounded-2xl bg-[#3B82F6] grid place-items-center text-white font-display text-lg">TPL</span>
          <span className="leading-tight">
            <span className="block font-display font-bold text-lg">Teach Play to Learn</span>
            <span className="block text-xs uppercase tracking-[0.18em] text-muted-foreground">Little Rock, AR</span>
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-7 text-sm font-semibold" aria-label="Site">
          {LINKS.map(([label, to]) => (
            <Link key={label} to={to} className="hover:text-[#3B82F6]" style={{ transition: "color .2s ease" }}
                  data-testid={`shell-nav-${label.toLowerCase()}`}>{label}</Link>
          ))}
        </nav>
        <Link to="/login" className="text-sm font-bold text-[#3B82F6]" data-testid="shell-login">Staff &amp; family sign in</Link>
      </div>
    </header>
    <main className="mx-auto max-w-6xl px-5 sm:px-8 py-10 sm:py-14">{children}</main>
    <footer className="bg-[#0F172A] text-white/70 px-5 sm:px-8 py-12">
      <div className="mx-auto max-w-6xl flex flex-col sm:flex-row gap-5 justify-between">
        <p className="font-display text-white font-bold">Teach Play to Learn Childcare &amp; Preschool Academy</p>
        <div className="flex gap-6 text-sm font-semibold">
          <Link to="/careers" className="hover:text-[#FBBF24]">Careers</Link>
          <Link to="/apply" className="hover:text-[#FBBF24]">Enroll a child</Link>
          <Link to="/login" className="hover:text-[#FBBF24]">Portal</Link>
        </div>
      </div>
    </footer>
  </div>
);
